import { getType } from 'typesafe-actions';

import * as userRoleActions from './actions';
import { UserRoleActionType, UserRoleState } from './types';

const initialState: UserRoleState = {
  roles: {
    data: [],
    loading: false,
  },
  rolePermissions: {
    data: [],
    loading: false,
  },
  allPermissions: {
    data: [],
    loading: false,
  },
  addRolePermissionsLoading: false,
  removeRolePermissionsLoading: false,
};

const userRoleReducer = (
  state: UserRoleState = initialState,
  action: UserRoleActionType,
): UserRoleState => {
  switch (action.type) {
    case getType(userRoleActions.getUserRoles.request):
      return {
        ...state,
        roles: {
          ...state.roles,
          loading: true,
        },
      };

    case getType(userRoleActions.getUserRoles.success):
      return {
        ...state,
        roles: {
          data: action.payload.data,
          loading: false,
        },
      };

    case getType(userRoleActions.getUserRoles.failure):
      return {
        ...state,
        roles: {
          ...state.roles,
          loading: false,
        },
      };

    case getType(userRoleActions.fetchRolePermissions.request):
      return {
        ...state,
        rolePermissions: {
          data: [],
          loading: true,
        },
      };

    case getType(userRoleActions.fetchRolePermissions.success):
      return {
        ...state,
        rolePermissions: {
          data: action.payload.data,
          loading: false,
        },
      };

    case getType(userRoleActions.fetchRolePermissions.failure):
      return {
        ...state,
        rolePermissions: {
          ...state.rolePermissions,
          loading: false,
        },
      };

    case getType(userRoleActions.fetchAllPermissions.request):
      return {
        ...state,
        allPermissions: {
          ...state.allPermissions,
          loading: true,
        },
      };

    case getType(userRoleActions.fetchAllPermissions.success):
      return {
        ...state,
        allPermissions: {
          data: action.payload.data,
          loading: false,
        },
      };

    case getType(userRoleActions.fetchAllPermissions.failure):
      return {
        ...state,
        allPermissions: {
          ...state.allPermissions,
          loading: false,
        },
      };

    case getType(userRoleActions.addRolePermissions.request):
      return {
        ...state,
        addRolePermissionsLoading: true,
      };

    case getType(userRoleActions.addRolePermissions.success):
      return {
        ...state,
        addRolePermissionsLoading: false,
      };

    case getType(userRoleActions.addRolePermissions.failure):
      return {
        ...state,
        addRolePermissionsLoading: false,
      };

    case getType(userRoleActions.removeRolePermissions.request):
      return {
        ...state,
        removeRolePermissionsLoading: true,
      };

    case getType(userRoleActions.removeRolePermissions.success):
      return {
        ...state,
        removeRolePermissionsLoading: false,
      };

    case getType(userRoleActions.removeRolePermissions.failure):
      return {
        ...state,
        removeRolePermissionsLoading: false,
      };

    default:
      return state;
  }
};

export default userRoleReducer;
